// extracted by mini-css-extract-plugin
export var title = "benefits-module--title--igoz3";
export var btnWrapper = "benefits-module--btn-wrapper--y5sBG";
export var registrationButton = "benefits-module--registration-button--40BEz";